import { useEffect, useState } from 'react';
import defaultLogoWide from '../../../assets/images/cares/logo-wide.png';
import defaultMark from '../../../assets/images/cares/logo.png';
import { getCaresShellBootstrap } from './bootstrap';

export type ShellBrandingAssets = {
  desktopLogo: string;
  desktopDark: string;
  toggleLogo: string;
  toggleDark: string;
  alt: string;
};

const resolveTenantBranding = (): ShellBrandingAssets => {
  const activeBranding = getCaresShellBootstrap().activeTenantBranding;
  const desktopLogo = activeBranding?.logo_url ?? activeBranding?.logo_mark_url ?? defaultLogoWide;
  const desktopDark = activeBranding?.logo_url ?? activeBranding?.logo_mark_url ?? defaultLogoWide;
  const toggleLogo = activeBranding?.logo_mark_url ?? activeBranding?.logo_url ?? defaultMark;
  const toggleDark = activeBranding?.logo_mark_url ?? activeBranding?.logo_url ?? defaultMark;
  const alt = activeBranding?.company_name ? `${activeBranding.company_name} logo` : 'CARES logo';

  return {
    desktopLogo,
    desktopDark,
    toggleLogo,
    toggleDark,
    alt,
  };
};

export const useShellBranding = () => {
  const [branding, setBranding] = useState<ShellBrandingAssets>(() => resolveTenantBranding());

  useEffect(() => {
    const refreshBranding = () => {
      setBranding(resolveTenantBranding());
    };

    window.addEventListener('cares:bootstrap-updated', refreshBranding);

    return () => {
      window.removeEventListener('cares:bootstrap-updated', refreshBranding);
    };
  }, []);

  return branding;
};
